import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "headless-graphql-introduction"
    }}>{`Headless GraphQL Introduction`}</h1>
    <p>{`Want to build a website like `}<a parentName="p" {...{
        "href": "https://www.gumtree.com/"
      }}>{`Gumtree`}</a>{`, with Headless you can easily do that.`}</p>
    <p>{`Headless Graphql is a Buy & Sell application where yu will find everything that is needed for `}<strong parentName="p">{`a complete application`}</strong>{`. In this application we have used `}<strong parentName="p">{`Firebase as database, Hosting, Deployment`}</strong>{` solution, `}<strong parentName="p">{`Graphql as Server/Backend Api, Next.js as Server Side Ready Client Side/Frontend`}</strong>{`. This application is built for the user whom are looking for a whole application not just a Frontend template or a backend solution, Also the user want to learn how to built an application using `}<strong parentName="p">{`Graphql, Nextjs, Firebase`}</strong>{`. This Application can be your next `}<inlineCode parentName="p">{`MVP project`}</inlineCode>{` you can easily use this application to create a Buy & Sell service.`}</p>
    <p>{`Headless Application Provides The Below Feature which is needed to built a BUY & SELL service:`}</p>
    <ol>
      <li parentName="ol">{`FirebaseDatabaseIntegration.`}</li>
      <li parentName="ol">{`SmartSearchingandFiltering.`}</li>
      <li parentName="ol">{`LocationBasedSearchingandFiltering.`}</li>
      <li parentName="ol">{`RegularAuthentication&MobileAuthentication. 5. SocialSharing`}</li>
      <li parentName="ol">{`AdPost,PublishPost,DraftPost`}</li>
      <li parentName="ol">{`NearestPost`}</li>
      <li parentName="ol">{`SEOFriendly`}</li>
      <li parentName="ol">{`ServerSideRendering`}</li>
      <li parentName="ol">{`FavoritePost.`}</li>
      <li parentName="ol">{`User Profile Page.`}</li>
      <li parentName="ol">{`CategoryPage`}</li>
      <li parentName="ol">{`RecentPostPage`}</li>
      <li parentName="ol">{`NearestPostPage`}</li>
      <li parentName="ol">{`DedicatedSearchPage. 16. SinglePostPage.`}</li>
      <li parentName="ol">{`UserSettingsPage`}</li>
    </ol>
    <p>{`And Most importantly `}<strong parentName="p">{`Easy Deployment`}</strong>{`, Everything (GraphQl, Node.js, Firebase Functions, Apollo, Next.js) has been deployed into Firebase, So with our deployment solution you don’t have to take any headache for deploying separate servers. Check our deployment Section to know how easy it is to deploy.`}</p>
    <p>{`Now, we will discuss about this application in whole, how we have developed it, technologies being used, how the user can use it,`}</p>
    <p>{`The whole application is built on top of Monorepo Architecture using Lerna(`}<a parentName="p" {...{
        "href": "https://github.com/lerna/lerna"
      }}>{`https://github.com/lerna/lerna`}</a>{`) And Yarn. you will get details about the Folder Structure in the Next Section.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      